var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 12.375H32.625M3.375 13.5H32.625M7.875 21.375H16.875M7.875 24.75H12.375M6.75 29.25H29.25C30.1451 29.25 31.0035 28.8944 31.6365 28.2615C32.2694 27.6285 32.625 26.7701 32.625 25.875V10.125C32.625 9.22989 32.2694 8.37145 31.6365 7.73851C31.0035 7.10558 30.1451 6.75 29.25 6.75H6.75C5.85489 6.75 4.99645 7.10558 4.36351 7.73851C3.73058 8.37145 3.375 9.22989 3.375 10.125V25.875C3.375 26.7701 3.73058 27.6285 4.36351 28.2615C4.99645 28.8944 5.85489 29.25 6.75 29.25Z",
    stroke: "#65C953",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.fbfae05f5196d486c2c445e62c62a088.svg";
export { ForwardRef as ReactComponent };